import React from 'react'
import classNames from "classnames"

import { ReactComponent as Icon } from '../../../assets/svg/icons/plan-icon.svg'

import '../../../assets/sass/components/plans/plan-icon.scss'

const PlanIcon = ({
    plan,
    width = 20,
    height = 20
}) => {
    return (
        <Icon className={classNames("plan-icon", plan)} style={{ width, height }} />
    )
}

export default PlanIcon
